import React from 'react'
import PropTypes from 'prop-types'
import HazardousIcons from './HazardousIcons'
import HazardousText from './HazardousText'
import { Heading } from 'chemistry'

const isEmpty = hazardInfo => !hazardInfo || Object.keys(hazardInfo).length === 0 || hazardInfo.error

const HazardousBlock = ({ hazardInfo, translationMapping }) => {
  if (isEmpty(hazardInfo)) return null

  return (
    <div className='mxd-hazardous gap-1-5 flex flex-column'>
      <Heading size='md'>{translationMapping.productSafety}</Heading>
      <HazardousIcons hazardInfo={hazardInfo} />
      <HazardousText hazardInfo={hazardInfo} translationMapping={translationMapping} />
    </div>
  )
}

HazardousBlock.propTypes = {
  hazardInfo: PropTypes.shape({
    iconCodes: PropTypes.array,
    safetyInstructions: PropTypes.string,
    signalWord: PropTypes.string,
    warning: PropTypes.string
  }),
  translationMapping: PropTypes.shape({
    safetyInstructions: PropTypes.string,
    signalWord: PropTypes.string,
    warning: PropTypes.string,
    productSafety: PropTypes.string
  })
}

export default HazardousBlock
